// 9fbef606107a605d69c0edbcd8029e5d
/**
 * These are temporary changes for a dummy Bag page
 */
import { fromJS } from 'immutable';
import CARTPAGE_CONSTANTS from '../CartItemTile.constants';

const initialState = fromJS({
  editableItemData: {},
  isBackPackOOS: false,
  sflBackPackCall: null,
  isBossCartFromSwitch: false,
  socialProofCartData: [],
});

// eslint-disable-next-line complexity
const CartPage = (state = initialState, action) => {
  switch (action.type) {
    case CARTPAGE_CONSTANTS.GET_PRODUCT_SKU_INFO_SUCCESS:
      return state.set('editableItemData', fromJS(action.payload.product));
    case CARTPAGE_CONSTANTS.SET_PRODUCT_MULTIPACK_DATA:
      return state.set('editableItemMultiPackData', action.payload.product);
    case CARTPAGE_CONSTANTS.SET_TOGGLE_CART_ITEM_ERROR:
      return state.set('toggleError', action.payload);
    case CARTPAGE_CONSTANTS.CLEAR_TOGGLE_CART_ITEM_ERROR:
      return state.set('toggleError', null);
    case CARTPAGE_CONSTANTS.SET_TOGGLE_BOSS_BOPIS_CART_ITEM_ERROR:
      return state.set('toggleBossBopisError', action.payload);
    case CARTPAGE_CONSTANTS.CLEAR_TOGGLE_BOSS_BOPIS_CART_ITEM_ERROR:
      return state.set('toggleBossBopisError', null);
    case CARTPAGE_CONSTANTS.CART_LAODINGSTATE:
      return state.set('cartLoadingState', action.payload);
    case CARTPAGE_CONSTANTS.ADYEN_APPLEPAY_CART_LAODINGSTATE:
      return state.set('adyenApplePayCartLoadingState', action.payload);
    case CARTPAGE_CONSTANTS.CART_TILE_LOADINGSTATE:
      return state.set('tileLoadingState', action.payload);
    case CARTPAGE_CONSTANTS.STORE_UPDATING_STATE:
      return state.set('storeUpatingState', action.payload);
    case CARTPAGE_CONSTANTS.STORE_UPDATED_COMPLETED_STATE:
      return state.set('storeUpatedCompletedState', action.payload);
    case CARTPAGE_CONSTANTS.UPDATE_CART_ITEM:
      return state.set('cartItemUpdating', true);
    case CARTPAGE_CONSTANTS.UPDATE_CART_ITEM_COMPLETE:
      return state.set('cartItemUpdating', false);
    case CARTPAGE_CONSTANTS.SET_BOSS_CART_CHECKOUT:
      return state.set('isBossCartFromSwitch', action.payload);
    case CARTPAGE_CONSTANTS.SHIPMENT_PRODUCT_INVENTORY_DETAILS:
      return state.set('shipmentProductInventory', action.payload);
    case CARTPAGE_CONSTANTS.CHECKOUT_IN_PROGRESS:
      return state.set('checkoutInProgress', action.payload);
    case CARTPAGE_CONSTANTS.IS_BACKPACK_ALONE_ERROR:
      return state.set('isBackPackAloneError', action.payload);
    case CARTPAGE_CONSTANTS.BACKPACK_OOS_ERROR:
      return state.set('isBackPackOOS', action.payload);
    case CARTPAGE_CONSTANTS.SCROLL_TO_TILE:
      return state.set('scrollToTile', action.payload);
    case CARTPAGE_CONSTANTS.BACKPACK_SFL_CALL:
      return state.set('sflBackPackCall', action.payload);
    case CARTPAGE_CONSTANTS.LOAD_SOCIAL_PROOF_CART_DATA:
      return state.set('socialProofCartData', action.payload?.socialProofCartData);
    default:
      /* istanbul ignore else */
      if (state instanceof Object) {
        return fromJS(state);
      }
      return state;
  }
};

export default CartPage;
